/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiativeDependencyDto
 */
export interface InitiativeDependencyDto {
    /**
     * 
     * @type {string}
     * @memberof InitiativeDependencyDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDependencyDto
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDependencyDto
     */
    predecessorInitiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDependencyDto
     */
    successorInitiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof InitiativeDependencyDto
     */
    dependencyType?: string;
    /**
     * 
     * @type {number}
     * @memberof InitiativeDependencyDto
     */
    lagDays?: number;
}

/**
 * Check if a given object implements the InitiativeDependencyDto interface.
 */
export function instanceOfInitiativeDependencyDto(value: object): value is InitiativeDependencyDto {
    return true;
}

export function InitiativeDependencyDtoFromJSON(json: any): InitiativeDependencyDto {
    return InitiativeDependencyDtoFromJSONTyped(json, false);
}

export function InitiativeDependencyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiativeDependencyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'predecessorInitiativeId': json['predecessorInitiativeId'] == null ? undefined : json['predecessorInitiativeId'],
        'successorInitiativeId': json['successorInitiativeId'] == null ? undefined : json['successorInitiativeId'],
        'dependencyType': json['dependencyType'] == null ? undefined : json['dependencyType'],
        'lagDays': json['lagDays'] == null ? undefined : json['lagDays'],
    };
}

export function InitiativeDependencyDtoToJSON(json: any): InitiativeDependencyDto {
    return InitiativeDependencyDtoToJSONTyped(json, false);
}

export function InitiativeDependencyDtoToJSONTyped(value?: InitiativeDependencyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'predecessorInitiativeId': value['predecessorInitiativeId'],
        'successorInitiativeId': value['successorInitiativeId'],
        'dependencyType': value['dependencyType'],
        'lagDays': value['lagDays'],
    };
}

